// extracted by css-extract-rspack-plugin
export default {"codeContainer":"zTyhh","code":"it8Vw"};